import { useParams } from "react-router-dom";
import SaveTrasladoInventario from "../../shared/componente/save_traslado/SaveTrasladoInventario";
import { LoaderComponent } from "@/shared/components/ui";
import { useFetchGetTransitoInventarioById } from "@/shared/actions/erp/transito_inventaro.actions";


export default function EditTransferenciaInventarioPage() {

  const { id } = useParams();

  const {
    data,
    isLoading,
  } = useFetchGetTransitoInventarioById(id!)  


  if (isLoading) return <LoaderComponent />

  return (
    <SaveTrasladoInventario
      dataTransitoInventario={data}
      title="Borrador de Transferencia Inventario"
    />
  )

}